import { EMAIL_VALIDATION_REGEXP } from '../../constants/validationRegexp';
const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Required';
  }

  if (!values.email) {
    errors.email = 'Required';
  }

  if (values.email && !EMAIL_VALIDATION_REGEXP.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.checkbox) {
    errors.checkbox = 'Please read and accept the terms and conditions before proceeding';
  }

  return errors;
};

export default validate;
